import normalizeEngagements from './normalizeEngagements'

export default (entities, userToAdd, entityId, engagementMetadata) =>
	[...entities].map((entity) => {
		if (entity.entityId === entityId) {
			const newContact = {
				...userToAdd,
				isIgnored: false,
				dashboard:[],
				contactList: {
					hasAccess: false
				},
				engagements: normalizeEngagements(userToAdd.engagements, engagementMetadata)
			};
			const newContacts = [...entity.contacts, newContact];
			return {...entity, contacts: newContacts};
		}
		return {...entity};
	});
